module.exports = __webpack_public_path__ + "img/video8.7a6fa867.jpg";